import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/userStore.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: { title: 'Tours' }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: 'Login', hideNav: true }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { title: 'Register' }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('../views/LogoutView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: { title: 'Contact' }
  },
  {
    path: '/tours',
    name: 'tours',
    component: () => import('../views/ToursView.vue'),
    meta: { title: 'Tours' }
  },
  {
    path: '/tours/:slug',
    name: 'tour',
    component: () => import('../views/TourView.vue'),
    meta: { title: 'Tour' }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: { title: 'About us' }
  },
  {
    path: '/is-it-for-you',
    name: 'is-it-for-you',
    component: () => import('../views/IsItForYouView.vue'),
    meta: { title: 'Is it for you?' }
  },
  {
    path: '/resources/:slug',
    name: 'resource',
    component: () => import('../views/ResourceView.vue'),
    meta: { title: 'Resources' }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to) => {
  const store = useUserStore()

  if (to.meta.requiresAuth && store.isLoggedIn == false) return '/login'

  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
